import * as React from 'react';
import { IFieldBaseProperties, IFieldValueProperties, ISelectFieldItem, IFieldEvent } from './interfaces';
import { default as USACodeList, IUSAState } from '../../model/hros/common/codelist/USAStatesCodeList';
import SelectField from './SelectField';

const stateSelectFieldItems: ISelectFieldItem[] = USACodeList.states.map((state: IUSAState) : ISelectFieldItem => {
  return {
    label: state.name,
    value: state.abbreviation
  }
});

interface IUSAStateSelectProperties extends IFieldBaseProperties, IFieldValueProperties { }

export default class USAStateSelect extends React.PureComponent<IUSAStateSelectProperties> {
  render() {
    return <SelectField items={stateSelectFieldItems} placeholder="Please select a state" {...this.props} />
  }
}